import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
// import AWS from 'aws-sdk';
import axios, { AxiosRequestConfig } from 'axios';
import { useRootStore } from 'store';
import { apiBase } from 'shared-pages/common/api-helpfunc';

const gqlAddCollectionpointGeocoding = gql`
  mutation addCollectionpointGeocoding($data: CollectionpointGeocodingInput) {
    addCollectionpointGeocoding(data: $data) {
      id
    }
  }
`;

/* Hook */
interface GeocodeCollectionPointAXIOS {
  latitude: number;
  longitude: number;
}
export function useGeocodeCollectionPoint() {
  const { appStore, tableStore } = useRootStore();
  const [addCollectionpointGeocoding] = useMutation(gqlAddCollectionpointGeocoding);

  // const geocodeCollectionPointLocal = async (id: number, address: string): Promise<boolean> => {
  //   //-------------------------------------------------------------------
  //   AWS.config.update({
  //     region: 'eu-west-1',
  //     apiVersion: 'latest',
  //     credentials: {
  //       accessKeyId: 'AKIAJUDLFET7PRBLL5TQ',
  //       secretAccessKey: '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',
  //     },
  //   });
  //   //-------------------------------------------------------------------

  //   const credentials = new AWS.CognitoIdentityCredentials({
  //     IdentityPoolId: 'eu-west-1:e04bf341-6c6a-4a97-9223-2c17fda18848',
  //   });

  //   console.time('load location');
  //   const location = new AWS.Location({
  //     credentials,
  //     region: 'eu-west-1', // AWS.config.region, // region containing the identity pool
  //   });
  //   console.timeEnd('load location');

  //   const r = await location.listPlaceIndexes();
  //   console.log('listPlaceIndexes', r);

  //   // rsp.Results contains search results for geocoding
  //   console.log('find location start');
  //   console.time('find location');
  //   const rsp = await location
  //     .searchPlaceIndexForText({
  //       IndexName: 'Greece', // = ένα Place Index που έφτιαξα δες: https://eu-west-1.console.aws.amazon.com/location/places/home?region=eu-west-1#/
  //       Text: address,
  //       MaxResults: 1,
  //       FilterCountries: ['GRC'], // ISO 3166-1 alpha-3
  //       Language: 'el',
  //     })
  //     .promise();
  //   console.timeEnd('find location');
  //   // NOT FOUND
  //   if (!rsp || !rsp.Results || rsp.Results.length === 0) return false;

  //   const place = rsp.Results[0].Place;
  //   console.log('place', place);

  //   const data = {
  //     collectionPointId: id,
  //     geocodedDate: new Date(),
  //     geocodedAddress: address,
  //     geocodedJsonResult: JSON.stringify(place),
  //     validGeocoding: true,
  //     longitude: place.Geometry.Point[0],
  //     latitude: place.Geometry.Point[1],
  //     addressNumber: place.AddressNumber,
  //     municipality: place.Municipality,
  //     postalCode: place.PostalCode,
  //     region: place.Region,
  //     street: place.Street,
  //     subRegion: place.SubRegion,
  //   };
  //   const retId = await addCollectionpointGeocoding({ variables: { data: data } });

  //   return retId ? true : false;
  // };

  const geocodeCollectionPointAXIOS = async (
    id: number,
    address: string,
  ): Promise<GeocodeCollectionPointAXIOS | undefined> => {
    // Fetch data from server
    appStore.setBusy();
    const config: AxiosRequestConfig = {
      method: 'POST',
      url: `${apiBase()}/geocode`,
      data: address,
    };
    const geoPlace = await axios(config).catch((error) => {
      appStore.clearBusy();
      console.log(error);
    });
    appStore.clearBusy();
    console.log('place', geoPlace);

    if ((geoPlace as any)?.status !== 200 && !(geoPlace as any)?.data.latitude) {
      return;
    }
    const data = { collectionPointId: id, ...(geoPlace as any)?.data };
    // const retId = await addCollectionpointGeocoding({ variables: { data: data } });

    return {
      longitude: (geoPlace as any).data?.longitude,
      latitude: (geoPlace as any).data?.latitude,
    };
  };

  return { geocodeCollectionPoint: geocodeCollectionPointAXIOS };
}
